import { PayloadAction } from 'app/core/models/action';
import { RatePurpose } from 'app/profile/models/supplier-rating.model';


export const GET_PURPOSES = "[RATE] GET_PURPOSES";
export const GET_PURPOSES_SUCCESS = "[RATE] GET_PURPOSES_SUCCESS";

export class GetPurposes implements PayloadAction {
    readonly type = GET_PURPOSES;
    constructor(public payload?: any) {}
}

export class GetPurposesSuccess implements PayloadAction {
    readonly type = GET_PURPOSES_SUCCESS;
    constructor(public payload: RatePurpose[]) {}
}

export type SupplierRatingActions =
    | GetPurposes
    | GetPurposesSuccess;